
import * as Vue from "vue";
import useEmitter from "@contrarian/ui-shared/composables/useEmitter";
import { useStore } from "vuex";

export default Vue.defineComponent({
  props: ['alignTo', 'commodityId', 'productId', 'roundsAvailable', 'price', 'id'],
  components: {},
  setup() {
    const emitter = useEmitter();
    const store = useStore();
    const memberId = Vue.computed(() => store.state.account.memberId);
    const isOpen = Vue.ref(false);
    return {
      emitter,
      isOpen,
      memberId
    };
  },
  methods: {
    buttonClick(event: any) {
      if (!this.memberId) return;

      event.stopPropagation();
      event.preventDefault();
      const triggerElement = event.target;
      const {
        commodityId,
        productId,
        price,
        roundsAvailable,
        id
      } = this;
      const alignTo = this.prepareAlignTo(this.alignTo);
      const data = {
        id,
        commodityId,
        productId,
        price,
        roundsAvailable
      };
      this.emitter.emit('openShipPanel', {
        data,
        triggerElement,
        alignTo
      });
    },
    prepareAlignTo(alignTo: any) {
      const {
        rightOf,
        leftOf,
        centerOf
      } = alignTo;
      if (rightOf === 'parent') {
        return {
          rightOf: this.$el.parentElement
        };
      } else if (leftOf === 'parent') {
        return {
          leftOf: this.$el.parentElement
        };
      } else if (centerOf === 'parent') {
        return {
          centerOf: this.$el.parentElement
        };
      }
      return alignTo;
    }
  }
});
